module.exports = __webpack_public_path__ + "img/warehouse1.fbff76cb.png";